// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_2787e5dfdf--tooltip--iKIv0","arrow_tooltip":"_2787e5dfdf--arrow_tooltip--FnHui","arrow":"_2787e5dfdf--arrow--M3H38"};